import { BookingType } from '@shared/transactions-types';

import { isBookingType } from './isBookingType';

export const hasHctBookingType = isBookingType(
    BookingType.HCT_CASH_IN_NOA,
    BookingType.HCT_CASH_OUT_NOA,
    BookingType.HCT_POS_OUT_NOA,
);
